import { takeLatest } from "redux-saga";
import { put, call, select } from "redux-saga/effects";
import actiontypes from "../actiontypes";
import * as apicalls from "../api";
import checkResponseStatus from "../utils/api";
import { history } from "../store";
import * as selectors from "../selectors";

// Sagas

function* workflowLogin(action) {
  const { username, password } = action.payload;
  yield put({ type: actiontypes.LOGGING_IN });
  try {
    const response = yield call(apicalls.login, username, password);
    checkResponseStatus(response);

    const json = yield response.json();
    yield put({ type: actiontypes.LOGGED_IN, payload: json });
    yield history.replace("/map");
  } catch (err) {
    yield put({ type: actiontypes.LOGIN_FAILED });
  }
}

function* workflowFetchUsers(action) {
  const token = yield select(selectors.userToken);
  yield put({ type: actiontypes.FETCHING_USERS });
  try {
    const response = yield call(apicalls.loadUsers, token);
    checkResponseStatus(response);

    const json = yield response.json();
    yield put({ type: actiontypes.FETCHED_USERS, payload: json });
  } catch (err) {
    yield put({ type: actiontypes.FETCH_USERS_FAILED });
  }
}

function* workflowFetchUser() {
  const token = yield select(selectors.userToken);
  yield put({ type: actiontypes.FETCHING_USER });
  try {
    const response = yield call(apicalls.loadUser, token);
    checkResponseStatus(response);

    const json = yield response.json();
    yield put({ type: actiontypes.FETCHED_USER, payload: json });
  } catch (err) {
    yield put({ type: actiontypes.FETCH_USER_FAILED });
  }
}

function* workflowLogout() {
  yield history.replace("/map");
}

function* workflowSaveUser(action) {
  const token = yield select(selectors.userToken) || "";
  let response = {};
  let json = {};
  yield put({ type: actiontypes.SAVING_USER });
  try {
    response = yield call(apicalls.saveUser, token, action.payload);
    json = yield response.json();
    checkResponseStatus(response);
    yield put({ type: actiontypes.SAVED_USER, payload: json });

    if (!token) {
      yield history.push({
        pathname: "/registered"
      });
    }
  } catch (err) {
    yield put({ type: actiontypes.SAVE_USER_FAILED, payload: json });
  }
}

function* workflowValidateRegistration(action) {
  let response = {};
  let json = {};
  try {
    response = yield call(apicalls.validateRegistration, action.payload);
    json = yield response.json();
    checkResponseStatus(response);
    yield put({ type: actiontypes.VALIDATED_REGISTRATION, payload: json });
  } catch (err) {
    yield put({ type: actiontypes.VALIDATE_REGISTRATION_FAILED });
  }
}

function* workflowResetPassword(action) {
  let response = {};
  yield put({ type: actiontypes.RESETTING_PASSWORD });
  try {
    response = yield call(apicalls.resetPassword, action.payload);
    checkResponseStatus(response);
    yield put({ type: actiontypes.PASSWORD_RESET });
  } catch (err) {
    yield put({ type: actiontypes.RESET_PASSWORD_FAILED });
  }
}

function* workflowRequestPassword(action) {
  yield put({ type: actiontypes.REQUESTING_PASSWORD });
  yield call(apicalls.requestPassword, action.payload);
  yield put({ type: actiontypes.REQUESTED_PASSWORD });
}

// Watchers

export function* watchLogin() {
  yield* takeLatest(actiontypes.LOGIN, workflowLogin);
}

export function* watchLogout() {
  yield* takeLatest(actiontypes.LOGOUT, workflowLogout);
}

export function* watchFetchUsers() {
  yield* takeLatest(actiontypes.FETCH_USERS, workflowFetchUsers);
}

export function* watchFetchUser() {
  yield* takeLatest(actiontypes.FETCH_USER, workflowFetchUser);
}

export function* watchSaveUser() {
  yield* takeLatest(actiontypes.SAVE_USER, workflowSaveUser);
}

export function* watchValidateRegistration() {
  yield* takeLatest(
    actiontypes.VALIDATE_REGISTRATION,
    workflowValidateRegistration
  );
}

export function* watchRequestPassword() {
  yield* takeLatest(actiontypes.REQUEST_PASSWORD, workflowRequestPassword);
}

export function* watchResetPassword() {
  yield* takeLatest(actiontypes.RESET_PASSWORD, workflowResetPassword);
}



/** WEBPACK FOOTER **
 ** ./src/sagas/auth.js
 **/